<div class="">
    <div class="page-content">
        <div class="body-data">
            <div class="main">
                <div class="heading">
                    <h6>Notifications</h6>
                    <!-- <button>Mark All As Read</button> -->
                </div>
                <!-- <div class="sub">
                    <div class="checkbox">
                        <mat-checkbox name="check" color="warn">All Notifications</mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <mat-checkbox name=check color="warn">Read</mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <mat-checkbox name="check" checked color="warn">UnRead</mat-checkbox>
                    </div>
                    <div class="search custom-form">
                        <input type="text" class="arrow-img" placeholder="Last 7 Days">
                        <div class="custom-form">
                            <input placeholder="Search Projects" type="text" class="search-img">
                        </div>
                    </div>
                </div> -->
                <div class="table">
                    <div class="table">
                        <mat-table [dataSource]="dataSource" matSort>

                            <ng-container matColumnDef="createdAt">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>CREATED DATE</mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.createdAt}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="activityKey">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> ACTIVITY TYPE</mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.activityKey}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="rawMessage">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> DESCRIPTION </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.rawMessage}} </mat-cell>
                            </ng-container>


                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center" colspan="6">No data matching the filter</td>
                            </tr>
                        </mat-table>
                        <mat-paginator #paginator [length]="total_count" [disabled]="loading" [pageSize]="page_size" [pageIndex]="pageIndex"
                        [pageSizeOptions]="[10, 25, 50, 100]" (page)="paginationChange($event)"></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
